/**
 * @argument version : Has to be a SEAL version ( 3 seperated digits by . )
 * @example
 * isVersion('7.3.0') // true
 * isVersion('7.2') // false
 * isVersion('text') // false
 */
export function isVersion(version) {
    const reg = new RegExp(
        /^((([0-9]+)\.([0-9]+)\.([0-9]+)(?:.([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z]+)*))?)?)$/gm
    );
    return reg.test(version);
}
/**
 * @argument baseVer : The static version that we check against
 * @argument version : The current seal version
 * @example
 * isAfterOrEqual('7.3.0', '7.4.0') // True 7.4 > 7.3
 * isAfterOrEqual('7.3.0', '7.3.0') // True 7.3 = 7.3
 * isAfterOrEqual('7.3.0', '7.2.0') // False 7.2 < 7.3
 */
export function isAfterOrEqual(baseVer, version) {
    // If version not set then must be master build, defaults to latest version
    if (version === '' || version === null || typeof version === 'undefined') {
        return true;
    }

    if (isVersion(baseVer) && isVersion(version)) {
        const baseVerDigits = baseVer.split('.');
        const currVerDigits = version.split('.');
        const verLength =
            baseVerDigits.length >= currVerDigits.length
                ? baseVerDigits.length
                : currVerDigits.length;
        for (let i = 0; i < verLength; i += 1) {
            const baseNum = baseVerDigits[i] ? baseVerDigits[i] : 0;
            const verNum = currVerDigits[i] ? currVerDigits[i] : 0;
            if (verNum < baseNum) {
                return false;
            }
            if (verNum > baseNum) {
                return true;
            }
        }

        return true;
    }

    return undefined;
}
